<template>
  <div class="takeRedpack">
    <div class="arrowContent">
      <Icon name="arrow-left" size="25" color="#fff" @click="goHome" />
    </div>
    <div class="couponCome">
      <img src="@/assets/couponQRcode/couponCome.png" alt="" />
    </div>
    <div class="get">
      <img src="@/assets/couponQRcode/get.svg" alt="" />
    </div>

    <div class="couponPage">
      <div class="up">
        <div class="ticketType">
          {{ QrRedPacketDetail.redPacketType === 'all' ? '全平台' : '活动' }}
        </div>
      </div>
      <div class="down">
        <div
          class="rounded-lg overflow-hidden flex flex-row text-white bg-white mb-3 items-center justify-between h-24"
        >
          <div
            class="w-32 flex flex-col justify-center items-center p-3 flex-grow-0 flex-shrink-0 h-full text-red"
          >
            <div>
              <span class="text-xl">¥&nbsp;</span
              ><span
                class="leading-10 font-semibold"
                style="letter-spacing: 0.1rem; font-size: 2.5rem"
                >{{ QrRedPacketDetail.faceValue }}</span
              >
            </div>
            <div class="text-xs">满任意元可用</div>
          </div>
          <div class="text-left flex-grow ml-3">
            <div class="text-black text-sm mb-1">
              {{ QrRedPacketDetail.redPacketName }}
            </div>
            <div class="text-xs text-gray text-red">
              {{ QrRedPacketDetail.startDate }} -
              {{ QrRedPacketDetail.endDate }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="use">
      <Button round size="large" color="#fab13b" @click="takeRedpackUse"
        ><span style="font-size: 18px">立即领取</span></Button
      >
    </div>
  </div>
</template>

<script>
import { takeRedpackDetail, takeRedpack } from './webApi'
import { Toast, Icon, Button, Dialog } from 'vant'
import { getBindWechatInfo } from '@/api/login'
import { isWechat } from '@/utils/auth'

export default {
  name: 'takeRedpack',
  components: { Icon, Button },
  created() {

    this.takeRedpackDetail()
  },
  mounted() {},
  watch: {},
  computed: {},
  data() {
    return {
      QrRedPacketDetail: {},
    }
  },
  methods: {
    takeRedpackDetail() {

      console.log(
        ' this.$route.query.redPacketId ',
        this.$route.query.redPacketId
      )
      takeRedpackDetail({ redPacketId: this.$route.query.redPacketId })
        .then(({ data }) => {


          console.log('getRedpackDetail', data)

          this.QrRedPacketDetail = data
        })
        .catch((err) => {
          console.log(err)
        })
    },

    takeRedpackUse() {

      takeRedpack({ redPacketId: this.$route.query.redPacketId })
        .then((res) => {

          console.log('takeRedpackUse', res)
          Toast.success('领取成功')
        })
        .catch((err) => {
          console.log(err)
        })
    },

    goHome() {
      console.log(0)
      this.isBandingWechat()
    },
    async isBandingWechat() {
      const res = await getBindWechatInfo()

      console.log(1)
      if (!isWechat() || res.data) {
        console.log(2)
        this.$router.push('/')
      } else {
        console.log(3)
        Dialog.confirm({
          message: `您的手机号还未绑定微信<br/>绑定微信有助您账户安全 请绑定微信`,
          theme: 'round-button',
          confirmButtonText: '去绑定',
          cancelButtonText: '取消',
          showCancelButton: true,
          closeOnClickOverlay: true,
          beforeClose: (action, done) => {
            if (action === 'confirm') {
              done()
              this.$router.push({
                path: '/mine/setting',
              })
            } else {
              done()
              this.$router.push('/')
            }
          },
        }).catch(() => {})
      }
    },
  },
}
</script>

<style lang="less" scoped>
.takeRedpack {
  height: 100%;
  background: url('~@/assets/couponQRcode/couponPoster.jpg') no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;

  .arrowContent {
    padding: 30px 0 0 10px;
    display: flex;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .couponCome {
    padding: 0.2vw 6.13vw 4.67vw;
  }
  .get {
    padding: 0px 51px 145px 204px;
  }
  .couponPage {
    height: 34.13vw;
    margin: 0px 2.6vw 3.67vw 2.6vw;
    background: url('~@/assets/couponQRcode/couponPage.png') no-repeat;
    background-size: 100% 100%;

    .up {
      display: flex;
      justify-content: flex-end;
      .ticketType {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 32px;
        border-radius: 0 12px 0 12px;
        background-color: rgba(255, 225, 225, 1);
        width: 140px;
        font-size: 11px;
      }
    }
    .down {
    }
  }
  .use {
    padding: 10.2vw 22.6vw 25.67vw 22.6vw;
  }
}
</style>
